export default __webpack_public_path__ + "static/media/back-arrow.24b469a6.svg";